export const DESKTOP_MAX_SLIDE = 3;
export const TABLET_MAX_SLIDE = 2;
export const PHONE_MAX_SLIDE = 1;

export const TABLET_SLICK_BP = 992;
export const PHONE_SLICK_BP = 640;
